var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  "+_vm._s(_vm.page.name || _vm.page.pagePath)+"\n  "),_c('CBadge',{style:({
      color: ((_vm.getTemplateOption('menu_link_color')) + " !important"),
      backgroundColor: ("rgba(" + _vm.backgroundRgb + ", 0.08) !important")
    })},[_vm._v("\n    "+_vm._s(_vm.count)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }